import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import {
  GridView as GridViewIcon,
  ViewList as ViewListIcon,
} from '@mui/icons-material';

export type AssetViewMode = 'list' | 'grid';

interface AssetViewToggleProps {
  value: AssetViewMode;
  onChange: (value: AssetViewMode) => void;
}

const AssetViewToggle: React.FC<AssetViewToggleProps> = ({ value, onChange }) => (
  <ToggleButtonGroup
    value={value}
    exclusive
    onChange={(_, newValue: AssetViewMode | null) => {
      if (newValue !== null) onChange(newValue);
    }}
    size="small"
  >
    <ToggleButton value="list" aria-label="List view">
      <ViewListIcon fontSize="small" />
    </ToggleButton>
    <ToggleButton value="grid" aria-label="Card view">
      <GridViewIcon fontSize="small" />
    </ToggleButton>
  </ToggleButtonGroup>
);

export default AssetViewToggle;
